<template>
  <main class="flex-1">
    <section aria-labelledby="primary-heading" class="min-w-0 flex-1 h-full flex flex-col lg:order-last">
      <div class="p-5">
        <div class="text-right mb-2">
          <button v-on:click="toggleInviteModal" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto mb-8 mt-2">
            {{ $t('agent.invite') }}
          </button>
        </div>
        <div class="bg-white shadow overflow-hidden sm:rounded-md w-full">
          <ul role="list" class="divide-y divide-gray-200">
            <li v-for="agent of this.$root.agentStore.collection" v-bind:key="agent.id">
                <AgentListItem v-bind:agent="agent" />
            </li>
          </ul>
        </div>
        <AgentAdd v-if="inviteActive" v-on:invite-finished-event="toggleInviteModal" />
      </div>
    </section>
  </main>
</template>

<script>
import AgentListItem from './agents/AgentListItem.vue'
import AgentAdd from './agents/AgentAdd.vue'
import { useAgentStore } from '@/stores/agents'
import agentModel from '@/models/agent'

export default {
  name: 'AgentsPage',
  components: {
    AgentListItem,
    AgentAdd,
  },
  setup() {
    let agentStore = useAgentStore();
    return { agentStore };
  },
  created() {
    this.fetchAgentsList();
  },
  methods: {
    toggleInviteModal() {
      this.inviteActive = !this.inviteActive;
    },
    async fetchAgentsList() {
      let agents = await agentModel.fetchAllAgents(this.axios, this.$root.token);
      agents.data.data.forEach(agent => {
        this.agentStore.replaceOrAdd(agent);
      })
    },
  },
  data() {
    return {
      'inviteActive': false,
    }
  },
}
</script>
